import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import ItemMRPInfo from '../Cart/ItemMRPInfo';
import cx from 'classnames';
import * as actions from '../../actions';
import * as Constants from '../../constants';
import * as Helper from '../../utils/helper';
import MedTypeIcon from '@components/MedTypeIcon/MedTypeIcon';
import OrderOnCallButton from '../Button/OrderOnCallButton';
import DropdownInput from '../DropdownInput';
import ProductAlternatesInfo from '../ProductAlternatesInfo/ProductAlternatesInfo';
import { sendToGTM } from '../../utils/gtmHelper';
import * as AnalyticsHelper from '../../utils/analyticsHelper';
require('./ProductCard.scss');

export const AVAILABILITY_ICON_MAP = {
  [Constants.availabilityLevelEnum.GREEN]: require('@images/thumb_up_green.svg'),
  [Constants.availabilityLevelEnum.YELLOW]: require('@images/hand_yellow.svg'),
  [Constants.availabilityLevelEnum.RED]: require('@images/thumb_down_red.svg'),
};
class ProductCard extends Component {

  constructor(props) {
    super(props);
    this.state = {
      productDetails: props.productDetails,
      isFlipRecommended: props.productDetails.productSubstitutionAttributes == null ? false : props.productDetails.productSubstitutionAttributes.isFlipRecommended,
      hasAvailableSubstitutes: props.productDetails.productSubstitutionAttributes != null && props.productDetails.isSubstitutionAllowed,
      hasAvailableSimilarProducts: props.productDetails.similarProductsAttributes != null,
      hasVariants: props.productDetails.hasVariants,
      quantity: props.productDetails.quantity || '',
      isLoading: false,
      isSubstituted: false,
      isOriginalProduct: true,
      cartItem: {},
      productAlternateType: null
    };
  }

  componentDidMount() {
    const { productDetails, cart } = this.props;
    const cartItem = this.props.customer.omsEnabled ? Helper.getCartItemForProductV5(productDetails, cart) : Helper.getCartItemForProduct(productDetails, cart);
    const { substitutionInfo } = cartItem;
    if (substitutionInfo && substitutionInfo.originalUcode === productDetails.ucode) {
      const { substitutedProductDetails: substitutedProduct } = substitutionInfo;
      this.setState({
        productDetails: {
          ...cartItem,
          flagId: substitutedProduct.flagId,
          listPriceDecimal: cartItem.amountDecimal,
          availabilityLevel: substitutedProduct.availabilityLevel,
          canBeSold: true,
          ucode: substitutedProduct.ucode,
          variants,
        },
        quantity: cartItem.quantity
      });
    }
    this.setState({
      isSubstituted: cartItem.substitutionInfo ? true : false,
      isOriginalProduct: cartItem.substitutionInfo && cartItem.substitutionInfo.substitutedUcode === productDetails.ucode ? false : true,
      cartItem: cartItem
    });
  }

  componentDidUpdate(prevProps) {
    const { cart } = this.props;
    const { productDetails, cartItem } = this.state;

    if ([Constants.GET_CART_SUCCESS, Constants.GET_CART_V5_SUCCESS, Constants.REMOVE_FROM_CART_SUCCESS].includes(cart.action.type) && prevProps.cart.action.type !== cart.action.type) {
      const newCartItem = this.props.customer.omsEnabled ? Helper.getCartItemForProductV5(productDetails, cart) : Helper.getCartItemForProduct(productDetails, cart);
      if (cartItem.itemId == newCartItem.itemId && cartItem.quantity == newCartItem.quantity) {
        return;
      }
      this.setState({ cartItem: newCartItem });
      this.updateProductQuantityFromCart(newCartItem);
    }
  }

  updateProductQuantityFromCart = (cartItem) => {
    const { quantity, isLoading } = this.state;
    if (isLoading) {
      return;
    }
    if (Number(cartItem.quantity) === Number(quantity)) {
      return;
    }

    this.setState({ quantity: cartItem.quantity || '', isLoading: false });
  }

  updateCartQty = async (itemId, qty) => {
    if (!itemId) {
      this.setState({ quantity: '' });
      return;
    }

    return await this.props.actions.updateCart({ itemId, quantity: qty });
  };

  addItemToCart = async (quantity) => {
    const {
      productDetails: product,
      productDetails: { productId, productType, name: productName },
      isSubstituted,
      isOriginalProduct
    } = this.state;

    const {
      productDetails: originalProduct
    } = this.props;

    let swappedProduct = Helper.getSwappedProduct(product);
    if (swappedProduct) {
      if (swappedProduct.shouldSwap) {
        this.props.actions.changeSearchText(swappedProduct.name);
      }
      return;
    }

    const { data: cartItem } = await this.props.actions.addToCart({ productId, productType, productName, quantity });

    if (isSubstituted && isOriginalProduct) {

      await this.props.actions.addSubstitutionRecord({
        itemId: cartItem.itemId,
        originalUcode: originalProduct.ucode,
        originalUcodeAvailability: originalProduct.availabilityLevel,
        substitutedUcode: product.ucode
      });

      await this.props.actions.fetchSubstitutedCartItems();

      this.props.actions.addSubstitutionEventLog([{
        logType: Constants.LOG_TYPE_SUBSTITUTE_ADDED_TO_CART,
        originalUcode: originalProduct.ucode,
        availability: originalProduct.availabilityLevel,
        substituteUcode: product.ucode,
        substituteType: this.state.productAlternateType,
        isOriginalFlipForGreen: !!((originalProduct.substituteDetails && originalProduct.substituteDetails.flip_for_green)),
        hasHighMarginSubstitutes: !!(originalProduct.substituteDetails && originalProduct.substituteDetails.has_higher_margin_substitutes),
      }]);

      sendToGTM({
        eventLabel: Constants.ADD_TO_CART_EVENT,
        eventDetails: {
          ...AnalyticsHelper.getCommonPayloadForAnalytics(this.props.customer, this.props.cart, this.props.user),
          product_id: productId,
          product_ucode: originalProduct.ucode,
          product_name: productName,
          product_alternate_type: this.state.productAlternateType,
          product_manufacturer: originalProduct.manufacturer,
          product_price: originalProduct.salePriceDecimal,
          product_rank: this.props.index
        }
      })
    }

    return true;
  };

  notifyDTPProduct = async (id) => {
    this.setState({ isLoading: true });
    await this.props.notifyDTPProduct(id);
    this.setState({ isLoading: false });
  }

  handleItemQtyChange = async ({ value: quantity }) => {
    const { resetInputFocus } = this.props;
    const { cartItem, isSubstituted } = this.state;
    this.setState({ quantity: quantity || '', isLoading: true });
    if (cartItem && cartItem.itemId) {
      await this.updateCartQty(cartItem.itemId, quantity);
    } else if (quantity > 0) {
      await this.addItemToCart(quantity);

      const { productDetails } = this.props;

      const showSubstitutes = productDetails.isSubstitutionAllowed && productDetails.productSubstitutionAttributes != null;
      const showVariants = productDetails.hasVariants;
      const showSimilarProducts = productDetails.similarProductsAttributes != null && !(showSubstitutes || showVariants);
    
      if((showSimilarProducts || showSubstitutes) && !isSubstituted) {
        this.props.actions.addSubstitutionEventLog([{
          logType: Constants.LOG_TYPE_SUBSTITUTES_AVAILABLE,
          isFlipRecommended: this.state.isFlipRecommended,
          originalUcode: productDetails.ucode,
          availability: productDetails.availabilityLevel,
          substituteUcode: null,
          substituteType: Constants.TYPE_SUBSTITUTE,
          isOriginalFlipForGreen: !!((productDetails.substituteDetails && productDetails.substituteDetails.flip_for_green)),
          hasHighMarginSubstitutes: !!(productDetails.substituteDetails && productDetails.substituteDetails.has_higher_margin_substitutes),
        }]);
      }

    }

    this.setState({ isLoading: false });
    resetInputFocus && resetInputFocus();

    return true;
  }

  handleSubstitution = async (substitutedProduct, productAlternateType = null) => {
    const { productDetails: originalProduct } = this.props;
    const { cartItem: { itemId } } = this.state;
    if (originalProduct.productId == substitutedProduct.id) {
      return;
    }
    if (itemId) {
      this.setState({
        isLoading: true
      });
      await this.props.actions.removeFromCart({ itemId });
      if(this.props.customer.omsEnabled) {
        this.props.actions.getCartItemsV5();
      } else {
        this.props.actions.getCartItems();
      }
    }
    const product = {
      flagId: substitutedProduct.flag_id,
      name: substitutedProduct.name,
      manufacturer: substitutedProduct.manufacturer_name || substitutedProduct.consumer_brand,
      measurementUnit: substitutedProduct.subtitle,
      discountPercent: substitutedProduct.discount_percent,
      listPriceDecimal: substitutedProduct.curated_mrp,
      salePriceDecimal: substitutedProduct.discounted_mrp,
      availabilityLevel: 1,
      productId: substitutedProduct.id,
      productType: originalProduct.productType,
      canBeSold: true,
      maxQuantity: substitutedProduct.max_sellable_quantity || 20,
      ucode: substitutedProduct.ucode,
      is_generic: !!substitutedProduct.is_generic,
    };

    this.setState({
      productDetails: product,
      isSubstituted: true,
      quantity: '',
      isOriginalProduct: true,
      isLoading: false,
      productAlternateType: productAlternateType
    });
  }

  isAlternateOptionAvailable() {
    const {
      isSubstituted,
      hasAvailableSimilarProducts,
      hasAvailableSubstitutes,
      hasVariants
    } = this.state;

    return isSubstituted || (hasAvailableSimilarProducts || hasAvailableSubstitutes || hasVariants)
  }

  resetSubstitute = async () => {
    const { productDetails: originalProduct } = this.props;
    const { cartItem: { itemId } } = this.state;

    if (itemId) {
      this.setState({
        isLoading: true
      });
      await this.props.actions.removeFromCart({ itemId });
      if(this.props.customer.omsEnabled) {
        this.props.actions.getCartItemsV5();
      } else {
        this.props.actions.getCartItems();
      }
    }

    this.setState({
      productDetails: originalProduct,
      quantity: '',
      isSubstituted: false,
      isOriginalProduct: true,
      isLoading: false
    });
  }

  render() {
    const {
      index,
      currentIndex,
      isInputFocused,
      notifiedProductIds,
      notifyDTPProduct,
      actions: { fetchProductAlternates, addSubstitutionEventLog, fetchSimilarProducts },
    } = this.props;
    const {
      quantity: itemQuantity,
      isLoading,
      productDetails,
      productDetails: {
        productAvailabilityFlags: { notifyMe: allowCustomerNotify } = {},
      },
      isSubstituted,
      isOriginalProduct,
      isFlipRecommended,
      cartItem: { substitutionInfo }
    } = this.state;
    const availabilityIcon = productDetails.availabilityLevel>=0 ? AVAILABILITY_ICON_MAP[productDetails.availabilityLevel] : null;
    const isNotified = notifiedProductIds.indexOf(productDetails.productId) > -1;
    const isCurrentlySelected = index == currentIndex;

    return (
      <div className={cx("ProductCard", { ActiveItem: isCurrentlySelected })}>
        {this.isAlternateOptionAvailable() && isFlipRecommended && (
          <div className="flipWarning">
            <img
              src={require("@images/medicine-flip.svg")}
              className="flipImage"
            />
            <span className="flipMessage">Low Chances of Delivery</span>
          </div>
        )}
        <div className="productDetailsContainer">
          {"flagId" in productDetails && (
            <MedTypeIcon flagId={productDetails.flagId} />
          )}
          <div className="productInfo">
            <div className="productName">{productDetails.name}</div>
            <div className="productManufacturer">
              {productDetails.manufacturer}
            </div>
          </div>
          <div className="productUnit">{productDetails.measurementUnit}</div>
          <div className="productPriceInfo">
            {('salePrice' in productDetails) && 
              <ItemMRPInfo
                discountPercent={productDetails.discountPercent}
                listPriceDecimal={productDetails.listPriceDecimal}
                salePriceDecimal={productDetails.salePriceDecimal}
                isGradedDiscountApplicable={productDetails.isGradedDiscountApplicable}
                omsEnabled={this.props.customer.omsEnabled}
                isCart={false}
              />
            }
          </div>
          {availabilityIcon ? (
            <div className="productAvailability">
              <img src={availabilityIcon} />
            </div>
          ) : !this.props.customer.omsEnabled && <div className="productAvailability">-</div>}
          {productDetails.canBeSold ||
          !isEmpty(productDetails.swappedProductDetails) ? (
            <DropdownInput
              options={Helper.createItemQtyArray(productDetails.maxQuantity)}
              onSelect={this.handleItemQtyChange}
              onChange={({ value }) => this.setState({ quantity: value })}
              placeholder="Add to cart"
              isOpen={isInputFocused && isCurrentlySelected}
              value={{ label: itemQuantity, value: itemQuantity }}
              className={cx("productCTA", { "pe-loading": isLoading })}
              isLoading={isLoading}
              emptyText="Not Allowed"
              pattern={/\d/g}
            />
          ) : (
            <div className="productCTA">
              {!notifyDTPProduct || !allowCustomerNotify ? (
                this.props.customer.omsEnabled ? ''  : "-"
              ) : (
                <OrderOnCallButton
                  text={
                    isNotified
                      ? "customer will be notified"
                      : "notify customer when in stock"
                  }
                  disabled={isNotified}
                  onClickFunction={() =>
                    this.notifyDTPProduct(productDetails.productId)
                  }
                  loading={this.state.isLoading}
                />
              )}
            </div>
          )}
        </div>
        {this.isAlternateOptionAvailable() && (
          <ProductAlternatesInfo
            originalProduct={
              !isOriginalProduct && substitutionInfo
                ? substitutionInfo
                : this.props.productDetails
            }
            isSubstituted={isSubstituted}
            isOriginalProduct={isOriginalProduct}
            handleSubstitution={this.handleSubstitution}
            resetSubstitute={this.resetSubstitute}
            fetchProductAlternates={fetchProductAlternates}
            fetchSimilarProducts={fetchSimilarProducts}
            addSubstitutionEventLog={addSubstitutionEventLog}
            productDetails={productDetails}
            isFlipRecommended={isFlipRecommended}
            isSubstitutionAllowed={
              this.props.productDetails.isSubstitutionAllowed
            }
          />
        )}
      </div>
    );
  }
}

ProductCard.propTypes = {
  productDetails: PropTypes.object.isRequired,
  cart: PropTypes.object.isRequired,
  actions: PropTypes.object,
  notifyDTPProduct: PropTypes.func,
  resetInputFocus: PropTypes.func,
  notifiedProductIds: PropTypes.array,
  isInputFocused: PropTypes.bool,
};

ProductCard.defaultProps = {
  actions: {},
  notifiedProductIds: [],
};

export default connect(state => ({
  cart: state.cart,
  customer: state.customer,
  user: state.user
}), dispatch => ({
  actions: bindActionCreators(actions, dispatch)
}))(ProductCard);
